
export default {
  motivoId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  descricaoMotivo: {
    value: null,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/modal/finish/cardfinishmodal-form.js